<template>
    <div>
        <!-- 工时/成本 -->
        <div class="card-line-header">
            <router-link :to="{ path: '/setHour',query:{ serialNumber:serialNumber,callback:getDetail}}">
                <el-button type="primary">设置工时</el-button>
            </router-link>
        </div>
        <el-table :data="detail.workTime">
            <el-table-column label="技术员" prop="worker"></el-table-column>
            <el-table-column label="实际处理时间" prop="timeLength"></el-table-column>
            <el-table-column label="操作">
                <template slot-scope="scope">
                    <el-button @click="handleDelClick(scope.row)" type="text" size="small">删除</el-button>
                </template>
            </el-table-column>
        </el-table>
    </div>
</template>

<script>
    import commonService from "../../../services/common.service"
    export default {
        props:{
            detail:Object,
            serialNumber:String,
            callback:Function
        },
        data() {
            return {}
        },
        created() {
            // console.log(this.detail)
        },
        methods: {
            getDetail(){
                
                this.callback()
            },
            handleDelClick(row){
                console.log(row)
                this.$confirm('是否删除?', '提示', {
                  confirmButtonText: '确定',
                  cancelButtonText: '取消',
                  type: 'warning'
                }).then(() => {
                    commonService.getWorkHoursDel({work_time_id:row.work_time_id}).then(res => {
                        this.$message({
                            type: 'success',
                            message: '删除成功!'
                        });
                        this.callback()
                    }).catch(err => {
                        this.$message.error(err.message);
                    })
                  
                }).catch(() => {
                  this.$message({
                    type: 'info',
                    message: '已取消删除'
                  });          
                });   
                
            }
        }
    }
</script>

<style lang="scss" scoped rel="stylesheet/scss">

</style>
